import _defineProperty from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { HttpRequest } from "@smithy/protocol-http";
import { SMITHY_CONTEXT_KEY } from "@smithy/types";
import { getSmithyContext } from "@smithy/util-middleware";
var defaultErrorHandler = function defaultErrorHandler(signingProperties) {
  return function (error) {
    throw error;
  };
};
var defaultSuccessHandler = function defaultSuccessHandler(httpResponse, signingProperties) {};
export var httpSigningMiddleware = function httpSigningMiddleware(config) {
  return function (next, context) {
    return /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(args) {
        var smithyContext, scheme, _scheme$httpAuthOptio, signingProperties, identity, signer, output;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (HttpRequest.isInstance(args.request)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", next(args));
              case 2:
                smithyContext = getSmithyContext(context);
                scheme = smithyContext.selectedHttpAuthScheme;
                if (scheme) {
                  _context.next = 6;
                  break;
                }
                throw new Error("No HttpAuthScheme was selected: unable to sign request");
              case 6:
                _scheme$httpAuthOptio = scheme.httpAuthOption.signingProperties, signingProperties = _scheme$httpAuthOptio === void 0 ? {} : _scheme$httpAuthOptio, identity = scheme.identity, signer = scheme.signer;
                _context.t0 = next;
                _context.t1 = _objectSpread;
                _context.t2 = _objectSpread({}, args);
                _context.t3 = {};
                _context.next = 13;
                return signer.sign(args.request, identity, signingProperties);
              case 13:
                _context.t4 = _context.sent;
                _context.t5 = {
                  request: _context.t4
                };
                _context.t6 = (0, _context.t1)(_context.t2, _context.t3, _context.t5);
                _context.next = 18;
                return (0, _context.t0)(_context.t6).catch((signer.errorHandler || defaultErrorHandler)(signingProperties));
              case 18:
                output = _context.sent;
                (signer.successHandler || defaultSuccessHandler)(output.response, signingProperties);
                return _context.abrupt("return", output);
              case 21:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  };
};